const reportStylesheet = `
@page {
  size: auto;
  margin: 0in;
}

@media print {
  @page {
    size: 8.5in 11.0in;
    margin: 0.5in 0.75in;
  }

  div.CoverPage {
    padding-top: 1.75in;
  }

  ul {
    margin-top: 1in;
  }
}

@media screen {
  .header {
    width: 100%;
    background-color: lightgray;
    text-align: center;
    position: fixed;
    padding: 5px;
    top: 0;
  }

  .footer {
    width: 100%;
    background-color: lightgray;
    text-align: center;
    position: fixed;
    padding: 5px;
    bottom: 0;
  }
}

@media print {

  .header,
  .header-space,
  .footer,
  .footer-space {
    width: 100%;
    height: 0.5in;
    text-align: center;
  }

  .header {
    position: fixed;
    top: 0;
  }

  .footer {
    position: fixed;
    bottom: 0;
  }

  .bottom {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0;
  }
}

body {
  display: table;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

div.CoverPage {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11pt;
  color: black;
  page-break-after: always;
}

div.ScenarioBuilder {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11pt;
  color: black;
}

.docHeader {
  display: flex;
  min-height: 1in;
  justify-content: space-between;
  vertical-align: middle;
}

.charcoalBox {
  background-color: #383432ff;
  color: #969695;
  width: calc(100% - 1.2in);
  text-align: center;
  vertical-align: middle;
  line-height: calc(1in - 32pt);
}

.rptTitle {
  font-size: 28pt;
  font-weight: 300;
  font-style: italic;
}

.greenBox {
  background-color: #8dc63f;
  width: 1in;
}

.timestamp {
  font-size: 12pt;
  float: right;
  margin-top: 0.25in;
}

ul {
  list-style: none;
  font-size: 12pt;
  font-weight: 600;
}

p.coverDetails {
  font-size: 11pt;
  font-weight: 500;
  margin: 0.1in;
}

.newPage {
  page-break-before: always;
}

.green {
  color: #8dc63f;
}

.sectionTitle {
  font-size: 14pt;
  text-decoration: underline;
}

.playTitle {
  color: #6A6765;
  font-weight: 500;
}

.subtitle {
  font-weight: bold;
  margin-right: 5px;
}

.classification {
  font-family: "Courier New", Courier, monospace;
}

.tool-list {
  margin-left: 25px;
}

hr {
  border-top: 1px solid #ccc;
  border-bottom: transparent;
  background-color: transparent;
  margin: 16px 0px;
}

.grey--text {
  color: #757575;
}

.dw_green--text {
  color: #8dc63f;
}

.info--text {
  color: #4E7D89;
}

.success--text {
  color: #26992f;
}

.warning--text {
  color: #cfaa30;
}

.danger--text {
  color: #eb4d4d;
}

.ptaas_critical--text {
  color: #EC3869;
}

.d-flex {
  display: flex;
}

.text-h2 {
  font-size: 3.75rem !important;
  line-height: 3.75rem;
  letter-spacing: -.0083333333em !important;
  font-weight: 300;
  font-family: Roboto, sans-serif !important;
}

.text-h3 {
  font-size: 3rem !important;
  line-height: 3.125rem;
  letter-spacing: normal !important;
  font-weight: 400;
  font-family: Roboto, sans-serif !important;
}

.text-h4 {
  font-size: 2.125rem !important;
  line-height: 2.5rem;
  letter-spacing: .0073529412em !important;
  font-weight: 400;
  font-family: Roboto, sans-serif !important;
}

.text-h5 {
  line-height: 2rem;
  font-family: Roboto, sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: 400;
  letter-spacing: normal !important;
}

.text-h6 {
  font-size: 1.25rem !important;
  font-weight: 500;
  letter-spacing: .0125em !important;
  line-height: 2rem;
  font-family: Roboto, sans-serif !important;
}

.overline {
  font-size: 0.75rem !important;
  font-weight: 500;
  letter-spacing: 0.1666666667em !important;
  line-height: 2rem;
  text-transform: uppercase;
  font-family: "Roboto", sans-serif !important;
}

.caption {
  font-size: 0.75rem !important;
  font-weight: 400;
  letter-spacing: 0.0333333333em !important;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif !important;
}

.text-subtitle-2 {
  font-size: .875rem !important;
  font-weight: 500;
  line-height: 1.375rem;
  letter-spacing: .0071428571em !important;
  font-family: Roboto, sans-serif !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-regular {
  font-weight: 500 !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}


.mb-0 {
  margin-bottom: 0px;
}

.mt-1 {
  margin-top: 4px;
}

.mt-2 {
  margin-top: 8px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.ml-1 {
  margin-left: 4px;
}

.ml-2 {
  margin-left: 8px;
}

.ml-3 {
  margin-left: 12px;
}

.ml-5 {
  margin-left: 20px;
}

.pa-0 {
  padding: 0px;
}

.pl-3 {
  padding-left: 12px;
}
`;

export default reportStylesheet;
